function ErrorPage(){  
  return (
    <div id="error-page">
      <h1>Oops!</h1>
      <p>Sorry, 404 Page not found</p>
    </div>
  );
}

export default ErrorPage;